import axios from "axios";

export async function getFileSize(url: string): Promise<number | null> {
  try {
    const response = await axios.head(url);
    const size = response.headers["content-length"];
    if (size) {
      console.log(`Size: ${(size / (1024 * 1024)).toFixed(2)} MB`);
      return Number(size);
    }
    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
}

export function formatFileSize(bytes: number): string {
  if (bytes >= 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  return `${(bytes / 1024).toFixed(1)} KB`;
}